export default __webpack_public_path__ + "img/eHFWndcP.a2126d2b.svg";